/* eslint-disable max-classes-per-file */
import Enum from '@rover/shared/js/types/Enum';

export const FONT_FAMILY =
  "'Averta-Regular', 'Avenir', 'Helvetica Neue', 'Calibri', 'Helvetica', 'Roboto', sans-serif";
export const FONT_FAMILY_SEMIBOLD =
  "'Averta-Semibold', 'Avenir', 'Helvetica Neue', 'Calibri', 'Helvetica', 'Roboto', sans-serif";
export class FontSize extends Enum<number> {
  static S = new FontSize(12);

  static M = new FontSize(14);

  static L = new FontSize(16);

  static XL = new FontSize(32);

  static XXL = new FontSize(40);

  static XXXL = new FontSize(48);

  toString(): string {
    return `${this.value}px`;
  }

  toNumber(): number {
    return this.value;
  }
}
export class FontWeight extends Enum<string> {
  static NORMAL = new FontWeight('normal'); // 400

  static HEAVY = new FontWeight('500');

  static BOLD = new FontWeight('600');

  static BOLDEST = new FontWeight('800');
}

const Font = {
  FontSize,
  FontWeight,
  FONT_FAMILY,
  FONT_FAMILY_SEMIBOLD,
};

export default Font;



// WEBPACK FOOTER //
// ../kibble/styles/Font.ts